import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import {
    Select,
    Input,
    OnOffSwitch
} from '../Common';
import {
    Grid,
    Divider
} from '@mui/material';
import useGetCountryDropdowns from '../../hooks/useGetCountryDropdowns';
import { TranslateW } from '../../Utils/Languages/Translate';

const LocationAddress = forwardRef((props, ref) => {
    const [physicalStreet, setPhysicalStreet] = useState(props.data.physicalStreet);
    const [physicalZip, setPhysicalZip] = useState(props.data.physicalZip);
    const [physicalStreet2, setPhysicalStreet2] = useState(props.data.physicalStreet2);
    const [physicalState, setPhysicalState] = useState(props.data.physicalState);
    const [physicalCountry, setPhysicalCountry] = useState(props.data.physicalCountry);
    const [physicalCity, setPhysicalCity] = useState(props.data.physicalCity);
    const [mailingStreet, setMailingStreet] = useState(props.data.mailingStreet);
    const [mailingZip, setMailingZip] = useState(props.data.mailingZip);
    const [mailingStreet2, setMailingStreet2] = useState(props.data.mailingStreet2);
    const [mailingState, setMailingState] = useState(props.data.mailingState);
    const [mailingCountry, setMailingCountry] = useState(props.data.mailingCountry);
    const [mailingCity, setMailingCity] = useState(props.data.mailingCity);
    const [latitude, setLatitude] = useState(props.data.lat);
    const [longitude, setLongitude] = useState(props.data.long);
    const [sameMailingAddress, setSameMailingAddress] = useState(props.data.sameMailingAddress);
    const [countryStates, setCountryStates] = useState([]);
    const [countryStatesMailing, setCountryStatesMailing] = useState([]);
    const { countries, states } = useGetCountryDropdowns();
    const [physicalAddressError, setPhysicalAddressError] = useState({
        physicalStreet: null,
        physicalZip: null,
        physicalState: null,
        physicalCountry: null,
        physicalCity: null
    });

    useEffect(() => {
        if (props.data.physicalCountry) {
            ChangeStates(props.data.physicalCountry, 'Physical')
        }
        if (props.data.mailingCountry) {
            ChangeStates(props.data.mailingCountry, 'Mailing')
        }
    }, [states]);

    const ChangeStates = (country, type) => {
        if (type == "Physical") {
            const filterStates = states.filter((state) => state.countryCode === country);
            // If select difference country, reset state value
            if (physicalCountry != country) {
                setPhysicalState("");
            }
            setCountryStates(filterStates);
            setPhysicalCountry(country)
        } else if (type === 'Mailing') {
            const filterStates = states.filter((state) => state.countryCode === country);
            // If select difference country, reset state value
            if (mailingCountry != country) {
                setMailingState("");
            }
            setCountryStatesMailing(filterStates);
            setMailingCountry(country);
        }
    };

    const changeErrorState = (name, value) => {
        setPhysicalAddressError(prev => ({
            ...prev,
            [name]: value
        }))
    }

    useImperativeHandle(ref, () => ({

        validate() {

            let foundError = false;

            if (!physicalStreet || physicalStreet === '') {
                changeErrorState('physicalStreet', true);
                foundError = true;
            } else {
                changeErrorState('physicalStreet', null);
            }

            if (!physicalZip || physicalZip === '') {
                changeErrorState('physicalZip', true);
                foundError = true;
            } else {
                changeErrorState('physicalZip', null);
            }

            if (!physicalState || physicalState === '') {
                changeErrorState('physicalState', true);
                foundError = true;
            } else {
                changeErrorState('physicalState', null);
            }

            if (!physicalCountry || physicalCountry === '') {
                changeErrorState('physicalCountry', true);
                foundError = true;
            } else {
                changeErrorState('physicalCountry', null);
            }

            if (!physicalCity || physicalCity === '') {
                changeErrorState('physicalCity', true);
                foundError = true;
            } else {
                changeErrorState('physicalCity', null);
            }

            if (foundError)
                props.setActiveStep(1);

            return !foundError;
        },

        submit() {
            return {
                physicalStreet,
                physicalZip,
                physicalStreet2,
                physicalState,
                physicalCountry,
                physicalCity,
                mailingStreet,
                mailingZip,
                mailingStreet2,
                mailingState,
                mailingCountry,
                mailingCity,
                lat: latitude,
                long: longitude,
                sameMailingAddress,
            }
        }

    }));

    return (
        <>
            <div className="wizardTitle">
                <span>Physical Address</span>
            </div>
            <Grid container spacing={4} mt={0.5}>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        required
                        fullWidth
                        value={physicalStreet}
                        label="Street"
                        onChange={e => setPhysicalStreet(e.target.value)}
                        error={physicalAddressError.physicalStreet}
                    />
                </Grid>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                   <Input
                        required
                        fullWidth
                        type="number"
                        value={physicalZip}
                        label="Zip"
                        onChange={e => setPhysicalZip(e.target.value)}
                        error={physicalAddressError.physicalZip}
                    />
                </Grid>
            </Grid>


            <Grid container style={{ marginTop: "2px" }} spacing={4}>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={physicalStreet2}
                        label="Street 2"
                        onChange={e => setPhysicalStreet2(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Select
                        required
                        label="Country"
                        value={physicalCountry}
                        onChange={e => ChangeStates(e.target.value, 'Physical')}
                        options={countries}
                        width={100}
                        error={physicalAddressError.physicalCountry}
                    />
                </Grid>
            </Grid>

            <Grid container style={{ marginTop: "2px" }} spacing={4}>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        required
                        fullWidth
                        value={physicalCity}
                        label="City"
                        onChange={e => setPhysicalCity(e.target.value)}
                        error={physicalAddressError.physicalCity}
                    />
                </Grid>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    {countryStates.length > 1 ? (
                        <Select
                            required
                            fullWidth
                            value={physicalState}
                            label={TranslateW("Profile.StateProvince")}
                            onChange={(e) => setPhysicalState(e.target.value)}
                            options={countryStates}
                            error={physicalAddressError.physicalState}
                        />
                    ) : (
                        <Input
                            required
                            fullWidth
                            value={physicalState}
                            label={TranslateW("Profile.StateProvince")}
                            onChange={(e) => setPhysicalState(e.target.value)}
                            error={physicalAddressError.physicalState}
                        />
                    )}
                </Grid>
            </Grid>

            <Grid container style={{ marginTop: "2px" }} spacing={4}>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={latitude}
                        label="Latitude"
                        onChange={e => setLatitude(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={longitude}
                        label="Longitude"
                        onChange={e => setLongitude(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ marginTop: "2px", marginBottom: '5px' }} spacing={4}>
                <Grid item xs={6} lg={6}>
                    <OnOffSwitch
                        label='Same Mailing Address'
                        value={sameMailingAddress}
                        onChange={() => setSameMailingAddress(!sameMailingAddress)}
                    />
                    <Divider sx={{ marginTop: "2.0%" }} />
                </Grid>
            </Grid>

            {!sameMailingAddress && (
                <div className='mailing-address-or-contact' style={{ marginTop: "2%" }}>
                    <div className="wizardTitle">
                        <span>Mailing Address</span>
                    </div>
                    <Grid container spacing={4} mt={0.5}>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            <Input
                                fullWidth
                                value={mailingStreet}
                                label="Street"
                                onChange={e => setMailingStreet(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            <Input
                                fullWidth
                                type="number"
                                value={mailingZip}
                                label="Zip"
                                onChange={e => setMailingZip(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: "2px" }} spacing={4}>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            <Input

                                fullWidth
                                value={mailingStreet2}
                                label="Street 2"
                                onChange={e => setMailingStreet2(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            <Select
                                label="Country"
                                value={mailingCountry}
                                onChange={e => ChangeStates(e.target.value, 'Mailing')}
                                options={countries}
                                width={100}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: "2px" }} spacing={4}>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            <Input

                                fullWidth
                                value={mailingCity}
                                label="City"
                                onChange={e => setMailingCity(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6} lg={6} style={{ marginBottom: '5px' }}>
                            {countryStatesMailing.length > 1 ? (
                                <Select
                                    fullWidth
                                    value={mailingState}
                                    label={TranslateW("Profile.StateProvince")}
                                    onChange={(e) => setMailingState(e.target.value)}
                                    options={countryStatesMailing}
                                />
                            ) : (
                                <Input
                                    fullWidth
                                    value={mailingState}
                                    label={TranslateW("Profile.StateProvince")}
                                    onChange={(e) => setMailingState(e.target.value)}
                                />
                            )}
                        </Grid>
                    </Grid>
                </div>
            )}
        </>
    );
});

export default LocationAddress;
